import { z } from "zod";
import { getDefaultBookingDates } from "../../../utils/dateTime";
export var accommodationValue = z.literal("accommodation");
export var pitchValue = z.literal("pitches");
export var allValue = z.literal("all");
export var noneValue = z.literal("none");
export var accommodationTypeGroup = z.union([
    accommodationValue,
    pitchValue,
    allValue,
    noneValue
]);
var defaultDates = getDefaultBookingDates();
export var formSchema = z.object({
    type: accommodationTypeGroup.default(allValue.value),
    campingPlace: z.string().optional(),
    campingPlaceType: z.enum([
        "campsite",
        "region"
    ]).optional(),
    campingPlaces: z.array(z.string()).optional(),
    arrivalDate: z.string().date().default(defaultDates.arrivalDate),
    departureDate: z.string().date().default(defaultDates.departureDate),
    adults: z.coerce.number().min(0).default(2),
    kids: z.coerce.number().min(0).default(0),
    ages: z.array(z.string()).optional(),
    features: z.record(z.string(), z.boolean().default(false)).default({}),
    attributes: z.record(z.string(), z.boolean().default(false)).default({}),
    stars: z.record(z.string(), z.boolean().default(false)).default({})
});
export var viewSchema = z.object({
    view: z.enum([
        "list",
        "map",
        "carousel"
    ]).optional(),
    map: z.object({
        lat: z.string().optional(),
        lng: z.string().optional(),
        zoom: z.string().optional(),
        selectedId: z.string().optional()
    }).optional()
});
